import { Outlet } from "react-router-dom";

import { useState } from "react";
import bgImage from "../../assets/images/reception.png";
import Aos from "../../components/Aos";
import Header from "../generalLayout/components/Header";
import BasicLayout from "./components/BasicLayout";

const AuthLayout = () => {
  const [showCartModal, setShowCartModal] = useState(false);

  return (
    <BasicLayout is4Auth image={bgImage}>
      <Aos />
      <Header setShowCartModal={setShowCartModal} />
      <Outlet />
    </BasicLayout>
  );
};

export default AuthLayout;
